export const MAIN_TEXT = 'Вітаємо в панелі адміністратора';
export const SUB_TEXT = 'Тут ви можете керувати контентом сайту';
export const HINT_TEXT = 'Оберіть категорію, щоб почати';
